import { render, staticRenderFns } from "./BookerPaymentDetails.vue?vue&type=template&id=012c1e34"
import script from "./BookerPaymentDetails.vue?vue&type=script&lang=js"
export * from "./BookerPaymentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports